import { tagName } from "@ember-decorators/component";
import AvatarFlair from "discourse/components/avatar-flair";
import SelectedNameComponent from "select-kit/components/selected-name";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const SelectedFlair = dt7948.c(class SelectedFlair extends SelectedNameComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.item.url}}\n      <AvatarFlair @flairName={{this.item.name}} @flairUrl={{this.item.url}} @flairBgColor={{this.item.bgColor}} @flairColor={{this.item.color}} />\n    {{/if}}\n\n    <span>{{this.label}}</span>\n  ", {
      strictMode: true,
      scope: () => ({
        AvatarFlair
      })
    }), this);
  }
}, [tagName("")]);
export default SelectedFlair;